import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "center-container" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 0,
  class: "loading"
}
const _hoisted_4 = { class: "button-panel" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubPanel = _resolveComponent("SubPanel")!
  const _component_UserPanel = _resolveComponent("UserPanel")!
  const _component_ContactPanel = _resolveComponent("ContactPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[1] || (_cache[1] = [
            _createElementVNode("p", null, "...Loading user data...", -1)
          ])))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                class: "home-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToHomepage()))
              }, " HOME ")
            ]),
            (_ctx.user)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_SubPanel, { user: _ctx.user }, null, 8, ["user"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.user)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_UserPanel, { user: _ctx.user }, null, 8, ["user"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createVNode(_component_ContactPanel)
            ])
          ], 64))
    ])
  ]))
}